import * as R from 'ramda';
import React from 'react';
import {of, throwError} from 'rxjs';
import {catchError, flatMap, map, tap} from 'rxjs/operators';
import {compose} from 'recompose';

import ajax from 'iss/utils/ajax';
import subscribeTo from 'iss/utils/subscriptionUtils';

import {getFormsByGradingScaleId} from 'iss/service/FormService';

export const gradingScales = ajax.cache("/grading-scale", 10 * ajax.MINUTES);

export function getScales() {
  return gradingScales;
}

export function getScale(scaleId) {
  return gradingScales.pipe(flatMap(scales => {
    const scale = R.find(R.propEq(scaleId, 'id'), scales);
    return scale ? of(scale) : throwError("Scale not found");
  }));
}

export function createScale(scale) {
  return ajax.postJson("/grading-scale", scale)
    .pipe(tap(gradingScales.clearCache));
}

export function modifyScale(scale) {
  return ajax.putJson("/grading-scale/"+scale.id, scale)
    .pipe(tap(gradingScales.clearCache));
}

export const minimumGradeValue = scale =>
  scale.grades.map(R.prop("numericValue")).reduce(R.min);

export function subscribeToGradingScale(WrappedComponent) {
  return function GradingScaleEditor({scaleId, newFromOld, ...props}) {
    const scaleObservable = scaleId ?
      getScale(scaleId).pipe(
        map(scale => newFromOld ? {...scale, id: null, newFromOld: true} : scale),
        catchError((error) => {
          console.error(`getScale with ${scaleId} failed:`, error);
          return of({ grades: []});
        })
      ) :
      of({
        name: "",
        gradeReportingStyle: "NAME_AND_NUMBER_VALUE",
        grades: []
      });

    const relatedFormsObservable = scaleId ?
      getFormsByGradingScaleId(scaleId).pipe(
        catchError((error) => {
          console.error(`getFormsByGradingScaleId with ${scaleId} failed:`, error);
          return of([]);
        })
      ) :
      of ([]);

    const SubscribedComponent = compose(
      subscribeTo(scaleObservable, 'scale'),
      subscribeTo(relatedFormsObservable,'relatedForms')
    )(WrappedComponent);

    return <SubscribedComponent {...props} />;
  };
}



// WEBPACK FOOTER //
// ./modules/issFrontend/service/GradingScaleService.js